module.exports = __webpack_public_path__ + "static/media/mark-github.e50abc21.svg";